import React, { useState } from 'react';

import {
  CmBox,
  CmButton,
  CmFormErrorMessage,
  CmLabelAndPasswordInput,
  CmVStack,
} from '@/components/uiParts';
import { useInput } from '@/hooks/Form';
import { ValidationError } from '@/lib/exception';

interface Props {
  onSubmit: (password: string, passwordConfirmation: string) => Promise<void>;
}

export const Form: React.FC<Props> = ({ onSubmit }): JSX.Element => {
  const [isShowPassword, setIsShowPassword] = useState<boolean>(false);
  const [password, passwordProps] = useInput(
    '',
    isShowPassword ? 'text' : 'password'
  );
  const [isShowPasswordConfirmation, setIsShowPasswordConfirmation] =
    useState<boolean>(false);
  const [confirmPassword, confirmPasswordProps] = useInput(
    '',
    isShowPasswordConfirmation ? 'text' : 'password'
  );
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage(null);

    await onSubmit(password, confirmPassword).catch((err) => {
      if (err instanceof ValidationError) {
        setErrorMessage(err.message);
      }
    });
  };

  return (
    <CmBox as="form" mx={4} onSubmit={handleSubmit}>
      <CmVStack spacing={'4'}>
        <CmLabelAndPasswordInput
          label={'パスワード'}
          id={'password'}
          handleShowPassword={() => setIsShowPassword((prev) => !prev)}
          {...{ ...passwordProps }}
          isShow={isShowPassword}
        />
        <CmLabelAndPasswordInput
          label={'パスワード（確認用）'}
          id={'PasswordConfirmation'}
          isInvalid={errorMessage !== null}
          handleShowPassword={() =>
            setIsShowPasswordConfirmation((prev) => !prev)
          }
          {...confirmPasswordProps}
          isShow={isShowPasswordConfirmation}
        >
          {errorMessage && (
            <CmFormErrorMessage>{errorMessage}</CmFormErrorMessage>
          )}
        </CmLabelAndPasswordInput>
      </CmVStack>
      {/*
       // @ts-ignore TS2590 */}
      <CmButton mt="8" type="submit" width="100%">
        本登録する
      </CmButton>
    </CmBox>
  );
};
